import Vue from 'vue';
import Router from 'vue-router';
import routes from './router'
import NProgress from 'nprogress'
import { serializationStringifyQuery, returnParseQuery } from "@/utils/query";
// import $fn from '@/utils/fn';
// import PageApi from '@/apis/pageApi'

// import {
//     getUserInfo,
// } from '@/req/user'

Vue.use(Router);

const router = new Router({
    mode: 'history',
	base: process.env.BASE_URL,
    // stringifyQuery: serializationStringifyQuery,
    // parseQuery: returnParseQuery,
	routes,
});

const routeType = ['/home', '/personalCenter', '/boundPhone', '/certification',
	'/service', '/verifyPhone', '/changePsd', '/pay'];
const idCard = ['/certification'];
import store from "@/store/index"

const originalPush: any = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

router.afterEach((to, from) => {
	NProgress.done();
	window.scrollTo(0, 0)
})

router.beforeEach(async (to, from, next) => {
	NProgress.start();
	const info = (store as any).state.user.info;
	const search = (store as any).state.user.searchUrl;
	// to.query = {...search, ...to.query};
	const type = routeType.indexOf(to.path) !== -1;
	const typeIdCard = idCard.indexOf(to.path) !== -1;
	if (!info.token && type) {
		store.dispatch('user/authRouter', true);
		return next({path: '/login', query: {...search, ...to.query}});
	} else if (!info.token) {
		store.dispatch('user/authRouter', true);
	} else if (info.age_status === 0 && !typeIdCard) {
		store.dispatch('user/authRouter', true);
		return next({path: '/certification', query: {...search, ...to.query}});
	} else if (info.age_status === 0) {
		store.dispatch('user/authRouter', true);
	}
	if (!to.query.appid) {
		return next({path: to.path, query: {...search, ...to.query}})
	}
	// 权限控制
	// if (to.meta && to.meta.auth && to.meta.auth.length > 0) {
	// 	// tslint:disable-next-line:prefer-const
	// 	for (let auth of to.meta.auth) {
	// 		// 登录权限校验
	// 		if (auth === 1) {
	// 			try {
	// 				// console.log(sessionStorage.getItem("token"))
	// 			} catch (err) {
	// 				// tslint:disable-next-line:no-console
	// 				console.log(err)
	// 			}
	// 		}
	// 	}
	// }
	/* 路由发生变化修改页面title */
	next();
	/* must call `next` */
})

export default router;
